import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';

import { bdsGridModeType } from '@bds/components';

import { CommunicationMessage, CommunicationService } from '@bds/core';
import { FastracDxGridWrapperComponent, FastracScreenBaseComponent } from '@bds/fastrac';
import { CarIdTransformService } from '@bds/helpers';

import { RtGpsAlertService } from '@bds/railtrac';

import { RtTrip, RtTripRefFieldDef, RtvGpsLocation } from '@bds/railtrac-models';

import { FastracColsService } from '@bds/services';

import { faBars } from '@fortawesome/pro-solid-svg-icons';
import DataSource from 'devextreme/data/data_source';
import ODataStore from 'devextreme/data/odata/store';
import { firstValueFrom, Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { PageService } from '@bds/core';
import { CreateTripService } from '@bds/railtrac';
import { ErrorListItem } from '@bds/rt-advance-models';
import { ErrorHandlerService } from '@bds/railtrac-internal-services';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
    selector: 'app-gps-alert-screen',
    templateUrl: './gps-alert-screen.component.html',
    styleUrl: './gps-alert-screen.component.scss',
    encapsulation: ViewEncapsulation.None,
})
export class GpsAlertScreenComponent
    extends FastracScreenBaseComponent
    implements OnInit, OnDestroy
{
    @ViewChild('dxGridWrapper') fastracGridComponent: FastracDxGridWrapperComponent;

    public gridSource: DataSource;
    public allowModeToggle = true;
    public selectedRowKeys: number[] = [];
    public selectedRowData: any[] = [];
    public gridId = 139;
    public gridMode: bdsGridModeType = 'multiple';
    public gridStore: ODataStore;

    gpsList: RtvGpsLocation[] = [];
    selectedRows: RtvGpsLocation[] = [];

    public isCreatingNew = false;
    public newTrip: RtTrip;

    public iconMenu = faBars;

    public tripRefFieldDefs$: Observable<RtTripRefFieldDef[]>;

    isDirty = false;
    errors: ErrorListItem[] = [];

    private ngUnsubscribe$: Subject<boolean> = new Subject<boolean>();

    get grid() {
        return this.fastracGridComponent?.grid;
    }

    constructor(
        public gpsAlertService: RtGpsAlertService,
        public dialog: MatDialog,
        public router: Router,
        public route: ActivatedRoute,
        pageService: PageService,
        public snackbar: MatSnackBar,
        public gridColumnService: FastracColsService,
        public carIdTransformService: CarIdTransformService,
        public communicationService: CommunicationService,
        private clipboard: Clipboard,
    ) {
        super(router, route, gridColumnService, communicationService, carIdTransformService);

        pageService.setHeader('GPS ALERTS');

        communicationService
            .getData()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe((m) => {
                const message: CommunicationMessage = m as CommunicationMessage;
                if (message && message.subscriberName === 'TripErrorScreen' && message.data) {
                    if (this.grid && this.grid.instance) {
                        void this.grid.instance.refresh();
                    }
                }
            });

        this.gridSource = this.gpsAlertService.getODataStore();
    }

    ngOnInit() {
        super.ngOnInit();
        this.grid?.instance.repaint();
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
        this.ngUnsubscribe$.next(true);
        this.ngUnsubscribe$.unsubscribe();
    }

    onDirty(): void {
        this.isDirty = true;
    }

    refreshGrid(): void {
        void this.grid.instance.refresh();
    }

    copyCarsToClipboard(): void {
        this.selectedRowData = this.grid.instance.getSelectedRowsData();
        if (this.selectedRowData != null && this.selectedRowData.length > 0) {
            const carIds = this.selectedRowData.map((eachRow) => {
                return (eachRow.carInit.trim() + eachRow?.carNo.trim()) as string;
            });
            const uniqueCars = [...new Set(carIds)];
            this.clipboard.copy(uniqueCars.join('\n'));
        }
    }

    onGridFastracIdChanged($event: number): void {
        super.onGridFastracIdChanged($event);
        void this.grid.instance.refresh();
    }
}
